import React from 'react';
import { message } from 'antd';
import { AuthenticationStoreContext } from '@/stores/authentication.store';
import ChangePasswordForm from '@components/accounts/ChangePasswordForm';
import { removeFromStorage } from '@utils/storage.util';

interface ComponentProps {
  setChangePasswordModal?: any;
}

const ChangePasswordPage = (props: ComponentProps) => {
  const { setChangePasswordModal } = props;

  const authenticationStore = React.useContext(AuthenticationStoreContext);

  const handleChangePassword = async (value: any) => {
    const result = await authenticationStore.changePassword({
      oldPassword: value.oldPassword,
      newPassword: value.newPassword,
    });

    if (result) {
      message.success('Your password has been changed!');
      removeFromStorage('token');
      authenticationStore.loggedUser = null;
    }
  };

  const handleCancel = () => {
    setChangePasswordModal(false);
  };

  return (
    <ChangePasswordForm
      handleChangePassword={handleChangePassword}
      handleCancel={handleCancel}
    />
  );
};

export default ChangePasswordPage;
